import { isMobileQuery, ipCountryQuery, configQuery, uniqueValues, getFeatureValueV2 } from '@gig/magic-common';
import { USER_LOGGED_IN_UPDATED, LANGUAGE_UPDATED, GAMES_LOADED, DEVICE_QUERY, GAMES_FETCH, GAMES_CATEGORIES_LIST, GAMES_LOBBIES_UPDATED, GAMES_PROVIDERS, GAMES_RECOMMENDED_GAMES, FEATURE_QUERY_ACTIVE, Feature, IP_COUNTRY_QUERY, USER_LOGGED_IN_QUERY } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
import { DynamicRecommendationsCategoryValues } from '@gig/magic-sdk/dist/adapter/games/category';
import { dynamicRecommendationCategories, isDynamicRecommendationCategory } from './filter-category.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var DynamicGRERecommendations;
(function(DynamicGRERecommendations2) {
  DynamicGRERecommendations2["USER"] = "dynamic-gre-main-user-recommendations";
  DynamicGRERecommendations2["MARKET"] = "dynamic-gre-main-market-recommendations";
  DynamicGRERecommendations2["GAME"] = "dynamic-gre-main-game-recommendations";
  DynamicGRERecommendations2["SUB_USER"] = "dynamic-gre-sub-user-recommendations";
  DynamicGRERecommendations2["SUB_MARKET"] = "dynamic-gre-sub-market-recommendations";
  DynamicGRERecommendations2["SUB_GAME"] = "dynamic-gre-sub-game-recommendations";
})(DynamicGRERecommendations || (DynamicGRERecommendations = {}));
class GamesFetchService {
  constructor() {
    this.games = null;
    this.updatedGREMainUserGames = null;
    this.updatedGRESubMainUserGames = null;
    this.categories = [];
    this.lobbies = [];
    this.recommendedGames = [];
    this.subscribeToLanguageChange();
    this.subscribeToLoggedInChanges();
  }
  subscribeToLoggedInChanges() {
    window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, () => __async(this, null, function* () {
      const categories = yield this.getUpdatedCategories();
      window.eventBus.publish(GAMES_CATEGORIES_LIST, categories);
    }), { replay: true });
  }
  subscribeToLanguageChange() {
    window.eventBus.subscribe(LANGUAGE_UPDATED, (event) => __async(this, null, function* () {
      window.eventBus.publish(GAMES_LOADED, false);
      const language = event.payload;
      const [
        device,
        isMobile,
        country,
        defaultGameCategories,
        defaultLobby
      ] = yield Promise.all([
        window.queryBus.query(DEVICE_QUERY),
        isMobileQuery(),
        ipCountryQuery(),
        configQuery("defaultGameCategories"),
        configQuery("defaultLobby")
      ]);
      const payload = yield magic.methods.games.fetch(isMobile, language, country, device, defaultGameCategories);
      yield this.setGamesAndCategories(payload, defaultLobby);
      window.eventBus.publish(GAMES_LOADED, true);
    }), { replay: true, distinct: true });
  }
  setGamesAndCategories(payload, defaultLobby) {
    return __async(this, null, function* () {
      this.preprocessGames(payload);
      this.preprocessCategories(payload, defaultLobby);
      yield this.addGreInformation();
      this.preprocessLobbies();
      window.eventBus.publish(GAMES_FETCH, this.games);
      const categories = yield this.getUpdatedCategories();
      window.eventBus.publish(GAMES_CATEGORIES_LIST, categories);
      window.eventBus.publish(GAMES_LOBBIES_UPDATED, this.lobbies);
      this.vendors = payload[2];
      window.eventBus.publish(GAMES_PROVIDERS, this.vendors);
      this.recommendedGames = payload[3];
      window.eventBus.publish(GAMES_RECOMMENDED_GAMES, this.recommendedGames);
    });
  }
  preprocessGames(payload) {
    this.games = Array.from(payload[0].entries()).reduce((map, [key, game]) => {
      map.set(key, __spreadProps(__spreadValues({}, game), {
        lobbies: [],
        category: this.getValidCategory(game)
      }));
      return map;
    }, new Map());
  }
  preprocessCategories(payload, defaultLobby) {
    this.categories = payload[1].map((cat) => {
      const category = __spreadValues({}, cat);
      if ("games" in cat) {
        category.games = cat.games || new Set();
      }
      if (!category.lobby) {
        category.lobby = defaultLobby;
      }
      return category;
    });
  }
  addGreInformation() {
    return __async(this, null, function* () {
      var _a, _b, _c;
      const isLoggedIn = yield this.isLoggedIn();
      const promises = [];
      for (const category of this.categories) {
        if ((_a = category.slug) == null ? void 0 : _a.includes(DynamicRecommendationsCategoryValues.GAME)) {
          promises.push(this.fetchSimilarGamesRecommendations(category.slug, this.games).then((similarGames) => {
            category.games = new Set(similarGames);
          }));
        }
        if ((_b = category.name) == null ? void 0 : _b.includes(DynamicRecommendationsCategoryValues.MARKET)) {
          promises.push(this.fetchMarketRecommendations(category.slug).then((marketGames) => {
            category.games = new Set(marketGames);
          }));
        }
        if (isLoggedIn && ((_c = category.name) == null ? void 0 : _c.includes(DynamicRecommendationsCategoryValues.USER))) {
          promises.push(this.fetchUserRecommendations(category.slug, this.games).then((userGames) => {
            category.games = new Set(userGames);
          }));
        }
      }
      return Promise.all(promises);
    });
  }
  preprocessLobbies() {
    if (this.games) {
      Array.from(this.games.values()).forEach((game) => {
        const lobbiesSet = new Set();
        this.categories.forEach((cat) => {
          var _a;
          if ((_a = cat.games) == null ? void 0 : _a.has(game.slug)) {
            lobbiesSet.add(cat.lobby);
          }
        });
        game.lobbies = Array.from(lobbiesSet);
      });
    }
    const uniqueLobbies = uniqueValues(this.categories.map((category) => category.lobby));
    this.lobbies = uniqueLobbies.map((lobby) => ({
      [lobby]: this.categories.filter((cat) => cat.lobby === lobby).map((cat) => cat.slug)
    }));
  }
  getValidCategory(game) {
    let { category, categories } = game;
    if (category === "mini-games" || category === "free-to-play-category") {
      categories = categories.filter((c) => c !== "mini-games" && c !== "free-to-play-category");
      category = categories[0] || "";
    }
    return category;
  }
  getUpdatedCategories() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      let categories = [...this.categories];
      const isLoggedIn = yield this.isLoggedIn();
      const dynamicCategoriesActive = yield this.isDynamicCategoriesActive();
      if (!dynamicCategoriesActive) {
        const dynamicSlugs = this.categories.filter((category) => dynamicRecommendationCategories(category)).map((category) => category.slug);
        categories = categories.filter((category) => !dynamicSlugs.includes(category.slug));
      }
      const dynamicCategoryValues = yield this.getDynamicCategoryValues();
      if (dynamicCategoryValues) {
        const dynamicCategories = categories.filter((category) => isDynamicRecommendationCategory(category, dynamicCategoryValues, isLoggedIn));
        const categoryMap = {
          [DynamicGRERecommendations.USER]: new Set(this.updatedGREMainUserGames || []),
          [DynamicGRERecommendations.SUB_USER]: new Set(this.updatedGRESubMainUserGames || []),
          [DynamicGRERecommendations.MARKET]: new Set(((_a = this.categories.find((cat) => {
            var _a2;
            return (_a2 = cat.name) == null ? void 0 : _a2.includes(DynamicRecommendationsCategoryValues.MARKET);
          })) == null ? void 0 : _a.games) || []),
          [DynamicGRERecommendations.SUB_MARKET]: new Set(((_b = this.categories.find((cat) => {
            var _a2;
            return ((_a2 = cat.name) == null ? void 0 : _a2.includes(DynamicRecommendationsCategoryValues.MARKET)) && !cat.main;
          })) == null ? void 0 : _b.games) || []),
          [DynamicGRERecommendations.GAME]: new Set(((_c = this.categories.find((cat) => cat.slug.includes(DynamicRecommendationsCategoryValues.GAME))) == null ? void 0 : _c.games) || []),
          [DynamicGRERecommendations.SUB_GAME]: new Set(((_d = this.categories.find((cat) => cat.slug.includes(DynamicRecommendationsCategoryValues.GAME) && !cat.main)) == null ? void 0 : _d.games) || [])
        };
        dynamicCategories.forEach((category) => {
          if (!categoryMap[category.slug]) {
            categoryMap[category.slug] = new Set();
          }
          category.games = categoryMap[category.slug];
        });
        return categories;
      }
      return categories;
    });
  }
  fetchMarketRecommendations(categorySlug) {
    return __async(this, null, function* () {
      try {
        const userLocation = yield ipCountryQuery();
        const response = yield magic.methods.games.getGREMarketRecommendations({
          category_slug: categorySlug,
          user_location: userLocation
        });
        if (!this.games) {
          return [];
        }
        const gameIds = Object.values(response.games);
        const filteredGames = Array.from(this.games.values()).filter((game) => gameIds.includes(game.gameId));
        return filteredGames.map((game) => game.slug);
      } catch (error) {
        console.error("Failed to fetch market recommendations:", error);
        return [];
      }
    });
  }
  fetchUserRecommendations(categorySlug, games) {
    return __async(this, null, function* () {
      try {
        const requestPayload = {
          category_slug: categorySlug,
          user_location: yield this.getIpCountry()
        };
        const response = yield magic.methods.games.getDynamicUserRecommendedCategory(requestPayload);
        if (!games) {
          return [];
        }
        const gameIds = Object.values(response.games);
        const filteredGames = Array.from(games.values()).filter((game) => gameIds.includes(game.gameId)).map((game) => game.slug);
        return filteredGames;
      } catch (e) {
        console.error("Failed to fetch user recommandations ", e);
        return [];
      }
    });
  }
  isDynamicCategoriesActive() {
    return window.queryBus.query(FEATURE_QUERY_ACTIVE, Feature.DYNAMIC_CATEGORY);
  }
  getDynamicCategoryValues() {
    return getFeatureValueV2(Feature.DYNAMIC_CATEGORY, "");
  }
  getIpCountry() {
    return window.queryBus.query(IP_COUNTRY_QUERY);
  }
  isLoggedIn() {
    return window.queryBus.query(USER_LOGGED_IN_QUERY);
  }
  fetchSimilarGamesRecommendations(categorySlug, games) {
    return __async(this, null, function* () {
      var _a;
      try {
        const category = this.categories.find((cat) => cat.slug.includes(categorySlug));
        if (!category) {
          return [];
        }
        const firstGameFromCMS = (_a = category.games) == null ? void 0 : _a.values().next().value;
        if (!firstGameFromCMS || !games) {
          return [];
        }
        const firstGame = games.get(firstGameFromCMS);
        if (!firstGame) {
          return [];
        }
        const params = {
          category_slug: categorySlug,
          game_id: firstGame.gameId
        };
        const response = yield magic.methods.games.getGRESimilarGameRecommendations(params);
        if (!games || !(response == null ? void 0 : response.games)) {
          return [];
        }
        const gameIds = Object.values(response.games).flat();
        const filteredGames = Array.from(games.values()).filter((game) => gameIds.includes(game.gameId)).map((game) => game.slug);
        return filteredGames;
      } catch (error) {
        console.error("Failed to fetch similar games recommendations:", error);
        return [];
      }
    });
  }
}

export { GamesFetchService };
